const hairColors = ['#00d4ff', '#7c3aed', '#f59e0b', '#ec4899', '#10b981', '#f97316', '#8b5cf6', '#06b6d4']
const skinTones = ['#f5d0b0', '#e8b88a', '#d4a574', '#c4956a', '#f0c8a0', '#e0b890', '#dba87a', '#ecc0a0']

function hashStr(s: string): number {
  let h = 0
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) | 0
  }
  return Math.abs(h)
}

export default function Avatar3D({ name }: { name: string }) {
  const h = hashStr(name)
  const hairColor = hairColors[h % hairColors.length]
  const skinTone = skinTones[(h >> 4) % skinTones.length]
  const hairIndex = (h >> 8) % 4
  const eyeColor = '#1a1a2e'

  const hairPaths = [
    <path key="hair1" d="M18 34c0-12 8.5-20 22-20 10 0 17 4 21 10 2-8 10-14 20-14 13 0 22 10 22 22 0 2 0 4-1 6H19c-1-2-1-4-1-4z" fill={hairColor} opacity="0.9" />,
    <path key="hair2" d="M16 38c0-14 10-26 24-26 8 0 15 4 20 10 5-8 14-14 24-14 14 0 24 12 24 26 0 2 0 4-1 6H17c-1-2-1-4-1-4z" fill={hairColor} opacity="0.9" />,
    <path key="hair3" d="M20 36c0-16 8-28 20-28 6 0 12 3 16 8 4-6 11-10 19-10 14 0 24 12 24 26v4H21a5 5 0 01-1-4z" fill={hairColor} opacity="0.9" />,
    <path key="hair4" d="M18 36c0-14 10-26 22-26 8 0 15 5 19 12 4-8 12-14 22-14 13 0 22 11 22 24v4H19c-1-2-1-4-1-4z" fill={hairColor} opacity="0.9" />,
  ]

  return (
    <svg viewBox="0 0 80 80" className="w-full h-full">
      <defs>
        <radialGradient id={`skin-${h}`} cx="40%" cy="35%" r="60%">
          <stop offset="0%" stopColor="#fff" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#000" stopOpacity="0.15" />
        </radialGradient>
        <radialGradient id={`hair-shine-${h}`} cx="40%" cy="20%" r="60%">
          <stop offset="0%" stopColor="#fff" stopOpacity="0.25" />
          <stop offset="100%" stopColor="#000" stopOpacity="0.1" />
        </radialGradient>
      </defs>

      {/* Shadow */}
      <ellipse cx="40" cy="72" rx="18" ry="4" fill="#000" opacity="0.15" />

      {/* Neck */}
      <rect x="34" y="56" width="12" height="10" rx="4" fill={skinTone} opacity="0.8" />

      {/* Head */}
      <circle cx="40" cy="36" r="22" fill={skinTone} />

      {/* Head 3D shading */}
      <circle cx="40" cy="36" r="22" fill={`url(#skin-${h})`} />

      {/* Hair */}
      <g>{hairPaths[hairIndex]}</g>

      {/* Hair shine */}
      <g clipPath="url(#head-clip)">{hairPaths[hairIndex]}</g>

      {/* Eyes */}
      <g>
        {/* Left eye */}
        <ellipse cx="33" cy="35" rx="3" ry="3.5" fill={eyeColor} />
        <ellipse cx="32.5" cy="34" rx="1.2" ry="1.2" fill="#fff" opacity="0.8" />
        {/* Right eye */}
        <ellipse cx="47" cy="35" rx="3" ry="3.5" fill={eyeColor} />
        <ellipse cx="46.5" cy="34" rx="1.2" ry="1.2" fill="#fff" opacity="0.8" />
      </g>

      {/* Eyebrows */}
      <path d="M29 31 Q33 28 37 31" stroke={hairColor} strokeWidth="1.2" fill="none" opacity="0.6" />
      <path d="M43 31 Q47 28 51 31" stroke={hairColor} strokeWidth="1.2" fill="none" opacity="0.6" />

      {/* Smile */}
      <path d="M34 42 Q40 47 46 42" stroke="#c44" strokeWidth="1.2" fill="none" strokeLinecap="round" />
    </svg>
  )
}
